import React, { Component } from "react";
import EditBracketDialog from "../../components/structure/EditBracketDialog";
import { languages } from "../../constants/languages";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { nextPouleName } from "../../util/NextPouleName";
import { getUploadErrorMessage } from "../../util/uploadErrors";
var robin = require("roundrobin");

class EditBracketContainer extends Component {
  state = {
    name: "",
    size: 8,
    scoreType: "default",
    scoreTypeChanged: false,
    numEncounters: 1,
    open: false,

    showSponsor: false,
    sponsorName: "",
    sponsorLogoURL: "",
    isUploading: false,
    errorMessageSponsor: "",
    newSponsorLogo: false,
  };

  UNSAFE_componentWillMount = () => {
    const bracket = this.props.bracket;
    if (bracket) {
      this.updateState(bracket);
    }
    if (this.props.numToBracket) {
      this.setState({ size: this.props.numToBracket });
    }
  };

  updateState = (bracket) => {
    let newState = {
      name: bracket.name || "",
      size: bracket.size || 8,
      scoreType:
        bracket.scoreType ||
        ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
          this.props.division.id
        ] || {})[this.props.fase] ||
        "default",
      scoreTypeChanged: false,
      showSponsor: bracket.showSponsor || false,
      sponsorName: bracket.sponsorName || "",
      sponsorLogoURL: bracket.sponsorLogoURL || "",
    };
    this.setState(newState);
  };

  handleShowSponsorChange = (event, checked) => {
    let newState = {};
    newState[event.target.name] = checked;
    this.setState(newState);
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "scoreType") {
      newState["scoreTypeChanged"] = true;
    }
    this.setState(newState);
  };

  setScoreType = (scoreType) => {
    this.setState({ scoreType: scoreType });
  };

  handleNumEncountersChange = (event) => {
    const numEncounters = event.target.value;
    let newState = {};
    newState["numEncounters"] = Number(numEncounters);
    this.setState(newState);
  };

  handleSizeChange = (event) => {
    const size = event.target.value;
    this.setState({ size: size });
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open });
      if (!this.state.open) {
        // reset state on closing dialog
        const bracket = this.props.bracket;
        if (bracket) {
          this.updateState(bracket);
        }
      }
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let tournamentVrsn = this.props.tournament.vrsn;
    const bracket = {
      name: this.state.name,
      size: this.props.subBracketTo ? this.props.numToBracket : this.state.size,
      scoreType: this.state.scoreType,
      division: this.props.division.id,
      fase: this.props.fase,
      showSponsor: this.state.showSponsor,
      sponsorName: this.state.sponsorName,
      sponsorLogoURL: this.state.sponsorLogoURL,
    };

    if (this.props.subBracketTo) {
      bracket["subBracketTo"] = this.props.subBracketTo;
    }

    const db = window.firebase.firestore();
    let batch = db.batch();

    var bracketRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("brackets");
    let bracketId = "";
    if (this.props.bracket) {
      bracketRef = bracketRef.doc(this.props.bracket.id);
      bracketId = this.props.bracket.id;
      batch.update(bracketRef, bracket);
    } else {
      let lastNum = -1;
      let lastLetter = "";
      let lastLetterOnline = "";
      for (let i = 0; i < Object.keys(this.props.bracketsByKey).length; i++) {
        const bracket =
          this.props.bracketsByKey[Object.keys(this.props.bracketsByKey)[i]];
        if (bracket.num >= lastNum) {
          lastNum = bracket.num;
          lastLetter = bracket.letter;
          if (tournamentVrsn >= 6) {
            lastLetterOnline = bracket.letterOnline || "";
          }
        }
      }

      for (let i = 0; i < Object.keys(this.props.poulesByKey).length; i++) {
        const poule =
          this.props.poulesByKey[Object.keys(this.props.poulesByKey)[i]];
        if (poule.num > lastNum && !poule.bracket) {
          lastNum = poule.num;
          lastLetter = poule.letter;
        }
      }

      bracket["num"] = lastNum + 1;
      bracket["letter"] = nextPouleName(lastLetter);
      if (tournamentVrsn >= 6) {
        bracket["letterOnline"] = nextPouleName(lastLetterOnline);
      }
      bracket["name"] =
        languages.structure.bracket +
        " " +
        (this.props.tournament.online && tournamentVrsn >= 6
          ? bracket.letterOnline
          : bracket.letter);
      bracketRef = bracketRef.doc();
      bracketId = bracketRef.id;
      batch.set(bracketRef, bracket);
      batch = this.makePoules(
        batch,
        bracketRef.id,
        this.props.tournament.online && tournamentVrsn >= 6
          ? bracket["letterOnline"]
          : bracket["letter"]
      );
    }

    let scoringTypesPerBracket =
      this.props.tournament.scoringTypesPerBracket || {};
    scoringTypesPerBracket[bracketId] = this.state.scoreType;
    batch.update(
      db.collection("tournaments").doc(this.props.tournament[".key"]),
      {
        scoringTypesPerBracket: scoringTypesPerBracket,
      }
    );
    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }

    if (this.state.scoreTypeChanged && this.props.bracket) {
      (this.props.poules || [])
        .filter((p) => p.bracket === this.props.bracket.id)
        .forEach((p) => {
          batch.update(
            db
              .collection("tournaments")
              .doc(this.props.tournament[".key"])
              .collection("poules")
              .doc(p.id),
            {
              scoreType: this.state.scoreType,
            }
          );
        });

      // check subbrackets
      let subBrackets = [];
      this.props.allBrackets.forEach((b) => {
        if (b.subBracketTo) {
          let parentBracket = this.props.bracketsByKey[b.subBracketTo] || {};
          let findingRootBracket = true;
          while (findingRootBracket) {
            if (parentBracket.id === this.props.bracket.id) {
              findingRootBracket = false;
            } else if (parentBracket.subBracketTo) {
              parentBracket =
                this.props.bracketsByKey[parentBracket.subBracketTo];
            } else {
              findingRootBracket = false;
            }
          }
          if (parentBracket.id === this.props.bracket.id) {
            subBrackets.push(b);
          }
        }
      });

      subBrackets.forEach((b) => {
        batch.update(
          db
            .collection("tournaments")
            .doc(this.props.tournament[".key"])
            .collection("brackets")
            .doc(b.id),
          {
            scoreType: this.state.scoreType,
          }
        );
        scoringTypesPerBracket[b.id] = this.state.scoreType;
        batch.update(
          db.collection("tournaments").doc(this.props.tournament[".key"]),
          {
            scoringTypesPerBracket: scoringTypesPerBracket,
          }
        );
        this.props.allPoules
          .filter((p) => p.bracket === b.id)
          .forEach((p) => {
            batch.update(
              db
                .collection("tournaments")
                .doc(this.props.tournament[".key"])
                .collection("poules")
                .doc(p.id),
              {
                scoreType: this.state.scoreType,
              }
            );
          });
      });
    }

    batch.commit().then(() => {
      if (this.state.sponsorLogoURL && this.state.newSponsorLogo) {
        var httpsReference = window.firebase
          .app()
          .storage("gs://tournament-uploads/")
          .refFromURL(this.state.sponsorLogoURL);
        httpsReference
          .updateMetadata({
            customMetadata: {
              sponsorType: "brackets",
              tournamentId: this.props.tournament[".key"],
              elementId: bracketId,
            },
          })
          .catch(function (error) {
            // Uh-oh, an error occurred!
            console.log(error.message);
          });
      }
      this.toggleDialog();
      this.setState({ scoreTypeChanged: false });
    });
  };

  makePoules = (batch, bracketId, bracketLetter) => {
    let round = 2;
    let pouleNum =
      this.props.poules.length === 0
        ? 0
        : this.props.poules[this.props.poules.length - 1].num + this.state.size;
    let matchNum = this.state.size;

    let poulesPerRound = {};
    let poulesPerRoundArrays = {};

    while (round <= this.state.size) {
      poulesPerRound[round] = {};
      poulesPerRoundArrays[round] = [];

      const poule = {
        pouleSize: "2",
        numEncounters: this.state.numEncounters,
        division: this.props.division.id,
        fase: this.props.fase,
        bracket: bracketId,
        singleMatch: true,
        bracketRound: round,
      };

      const db = window.firebase.firestore();

      let fromNum = round - 2;
      if (round === 2) {
        fromNum = 2;
      }

      for (let i = fromNum; i >= 0; i -= 2) {
        var pouleRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("poules");
        poule["name"] =
          languages.structure.matchCapital +
          " " +
          bracketLetter +
          matchNum.toString();
        poule["num"] = pouleNum;

        if (round === 2) {
          if (i === 2) {
            poule["losersFinal"] = true;
          } else {
            poule["losersFinal"] = false;
          }
        }

        pouleRef = pouleRef.doc();
        batch.set(pouleRef, poule);
        batch = this.makeMatches(batch, pouleRef.id, bracketId);

        let winnerToPoule = undefined;
        let winnerToNumInPoule = undefined;
        let loserToPoule = undefined;
        let loserToNumInPoule = undefined;
        if (round > 2) {
          const nextRound = poulesPerRound[round / 2];
          if (i % 4 === 0) {
            winnerToPoule = nextRound[i / 2];
            winnerToNumInPoule = 0;
            // losers final
            if (round === 4) {
              loserToPoule = nextRound[2];
              loserToNumInPoule = 0;
            }
          } else {
            winnerToPoule = nextRound[(i - 2) / 2];
            winnerToNumInPoule = 1;
            // losers final
            if (round === 4) {
              loserToPoule = nextRound[2];
              loserToNumInPoule = 1;
            }
          }
        }

        batch = this.makeResultSpots(
          batch,
          pouleRef.id,
          poule.num,
          winnerToPoule,
          winnerToNumInPoule,
          loserToPoule,
          loserToNumInPoule,
          bracketId,
          round
        );

        poulesPerRound[round][i] = pouleRef.id;
        poulesPerRoundArrays[round].push([pouleRef.id, i]);

        matchNum--;
        pouleNum--;
      }

      // for subbracket divide resultspots from parent bracket in first round
      // also set byes based on parent byes
      if (this.props.subBracketTo && round === this.state.size) {
        let losersFirstRoundParent = this.props.resultSpotsAll
          .filter(
            // eslint-disable-next-line
            (resultSpot) =>
              resultSpot.belongsToBracket === this.props.subBracketTo &&
              resultSpot.bracketRound === round * 2 &&
              resultSpot.rank === 1
          )
          .sort((a, b) => a.fromPouleNum - b.fromPouleNum);
        let firstRoundParent = poulesPerRound[round];
        let resultSpotsRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("resultSpots");
        let byesTemp = [];

        for (let i = 0; i < losersFirstRoundParent.length; i++) {
          let resultSpotToUpdate = losersFirstRoundParent[i];
          let parentPoule = resultSpotToUpdate.fromPoule;
          let setBye = false;
          if (parentPoule) {
            let parentPouleObj = this.props.poulesByKey[parentPoule] || {};
            if (
              parentPouleObj["status0"] === "bye" ||
              parentPouleObj["status1"] === "bye"
            ) {
              setBye = true;
            }
          }
          let toUpdate = {};
          let toUpdatePoule = {};
          if (i % 2 === 0) {
            toUpdate["poule" + this.props.fase] = firstRoundParent[i];
            toUpdate["numInPoule" + this.props.fase] = 0;
            if (setBye) {
              toUpdatePoule["status0"] = "bye";
              batch.update(
                db
                  .collection("tournaments")
                  .doc(this.props.tournament[".key"])
                  .collection("poules")
                  .doc(firstRoundParent[i]),
                toUpdatePoule
              );
              byesTemp.push(firstRoundParent[i] + "0");
              if (round === 4) {
                // set bye in losers final
                let toUpdatePouleLoser = {};
                if (Math.floor(i / 2) === 0) {
                  toUpdatePouleLoser["status0"] = "bye";
                } else if (Math.floor(i / 2) === 1) {
                  toUpdatePouleLoser["status1"] = "bye";
                }

                batch.update(
                  db
                    .collection("tournaments")
                    .doc(this.props.tournament[".key"])
                    .collection("poules")
                    .doc((poulesPerRound[2] || {})[2]),
                  toUpdatePouleLoser
                );
              }
            }
          } else {
            toUpdate["poule" + this.props.fase] = firstRoundParent[i - 1];
            toUpdate["numInPoule" + this.props.fase] = 1;
            if (setBye) {
              toUpdatePoule["status1"] = "bye";
              batch.update(
                db
                  .collection("tournaments")
                  .doc(this.props.tournament[".key"])
                  .collection("poules")
                  .doc(firstRoundParent[i - 1]),
                toUpdatePoule
              );
              if (round === 4) {
                // set bye in losers final
                let toUpdatePouleLoser = {};
                if (Math.floor(i / 2) === 0) {
                  toUpdatePouleLoser["status0"] = "bye";
                } else if (Math.floor(i / 2) === 1) {
                  toUpdatePouleLoser["status1"] = "bye";
                }

                batch.update(
                  db
                    .collection("tournaments")
                    .doc(this.props.tournament[".key"])
                    .collection("poules")
                    .doc((poulesPerRound[2] || {})[2]),
                  toUpdatePouleLoser
                );
              }
              let allRoundsChecked = false;
              let currentPouleId = firstRoundParent[i - 1];
              let currentNumInPoule = i % 2;
              let nextPouleNum = Math.floor(i / 4);
              let nextNumInPoule = Math.floor(i / 2) % 2;
              let currentRound = round;
              while (!allRoundsChecked) {
                let opponentIsBye =
                  byesTemp.indexOf(
                    currentPouleId + (currentNumInPoule === 0 ? "1" : "0")
                  ) !== -1;
                if (opponentIsBye) {
                  let poulesForRound =
                    poulesPerRoundArrays[currentRound / 2] || [];
                  poulesForRound.sort((a, b) => a[1] - b[1]);

                  let nextPouleId = (poulesForRound[nextPouleNum] || {})[0];

                  let toUpdateNextPoule = {};
                  toUpdateNextPoule["status" + nextNumInPoule] = "bye";
                  if (nextPouleId) {
                    if (currentRound / 2 === 4) {
                      // set bye in losers final
                      let toUpdatePouleLoser = {};
                      if (nextPouleNum === 0) {
                        toUpdatePouleLoser["status0"] = "bye";
                      } else if (nextPouleNum === 1) {
                        toUpdatePouleLoser["status1"] = "bye";
                      }

                      batch.update(
                        db
                          .collection("tournaments")
                          .doc(this.props.tournament[".key"])
                          .collection("poules")
                          .doc((poulesPerRound[2] || {})[2]),
                        toUpdatePouleLoser
                      );
                    }

                    batch.update(
                      db
                        .collection("tournaments")
                        .doc(this.props.tournament[".key"])
                        .collection("poules")
                        .doc(nextPouleId),
                      toUpdateNextPoule
                    );

                    byesTemp.push(nextPouleId + nextNumInPoule);
                    currentPouleId = nextPouleId;
                    currentNumInPoule = nextNumInPoule;
                    nextNumInPoule = nextPouleNum % 2;
                    nextPouleNum = Math.floor(nextPouleNum / 2);
                    currentRound = currentRound / 2;
                  } else {
                    allRoundsChecked = true;
                  }
                } else {
                  allRoundsChecked = true;
                }
              }
            }
          }
          batch.update(resultSpotsRef.doc(resultSpotToUpdate.id), toUpdate);
        }
      }

      round = round * 2;
    }
    return batch;
  };

  makeMatches = (batch, pouleId, bracketId) => {
    let teams = [];
    for (let i = 0; i < 2; i++) {
      teams.push({
        id: i,
      });
    }
    const db = window.firebase.firestore();

    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");

    let rounds = robin(teams.length, teams);
    let num = 0;
    let roundNum = 0;
    for (let i in rounds) {
      let round = rounds[i];
      for (let j in round) {
        let match = round[j];
        let newMatch = {
          round: roundNum,
          poule: pouleId,
          bracket: bracketId,
          numInPoule: num,
          team1: match[0].id,
          team2: match[1].id,
          score1: null,
          score2: null,
          field: null,
        };
        num++;
        const newRef = matchesRef.doc();
        batch.set(newRef, newMatch);
      }
      roundNum++;
    }

    if (this.state.numEncounters === 2) {
      for (let i in rounds) {
        let round = rounds[i];
        for (let j in round) {
          let match = round[j];
          let newMatch = {
            round: roundNum,
            poule: pouleId,
            bracket: bracketId,
            numInPoule: num,
            team1: match[1].id,
            team2: match[0].id,
            score1: null,
            score2: null,
            field: null,
          };
          num++;
          const newRef = matchesRef.doc();
          batch.set(newRef, newMatch);
        }
        roundNum++;
      }
    }

    // delete old matches
    if (this.props.matches) {
      for (let x in this.props.matches) {
        let oldMatch = this.props.matches[x];
        batch.delete(matchesRef.doc(oldMatch.id));
      }
    }

    return batch;
  };

  makeResultSpots = (
    batch,
    pouleId,
    pouleNum,
    winnerToPoule,
    winnerToNumInPoule,
    loserToPoule,
    loserToNumInPoule,
    bracketId,
    bracketRound
  ) => {
    const db = window.firebase.firestore();

    const resultSpotsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots");

    // delete old result spots
    if (this.props.resultSpotsNotDivided) {
      for (let x in this.props.resultSpotsNotDivided) {
        let oldResultSpot = this.props.resultSpotsNotDivided[x];
        batch.delete(resultSpotsRef.doc(oldResultSpot.id));
      }
    }

    for (let i = 0; i < 2; i++) {
      let resultSpot = {
        fromPoule: pouleId,
        fromPouleNum: pouleNum,
        rank: i,
        type: 0,
        fase: this.props.fase,
        division: this.props.division.id,
        belongsToBracket: bracketId,
        bracketRound: bracketRound,
      };
      if (
        winnerToPoule !== undefined &&
        winnerToNumInPoule !== undefined &&
        i === 0
      ) {
        resultSpot["poule" + this.props.fase] = winnerToPoule;
        resultSpot["numInPoule" + this.props.fase] = winnerToNumInPoule;
      }

      if (
        loserToPoule !== undefined &&
        loserToNumInPoule !== undefined &&
        i === 1
      ) {
        resultSpot["poule" + this.props.fase] = loserToPoule;
        resultSpot["numInPoule" + this.props.fase] = loserToNumInPoule;
      }

      let newRef = resultSpotsRef.doc();
      for (let x in this.props.resultSpotsNotDivided) {
        let oldResultSpot = this.props.resultSpotsNotDivided[x];
        if (oldResultSpot.rank === i) {
          resultSpot = oldResultSpot;
          newRef = resultSpotsRef.doc(oldResultSpot.id);
        }
      }

      batch.set(newRef, resultSpot);
    }

    return batch;
  };

  handleDeleteSponsor = () => {
    let toUpdate = { sponsorLogoURL: "", newSponsorLogo: false };
    this.setState(toUpdate);
    // let urlToDelete = this.state.sponsorLogoURL;

    // window.firebase
    //   .firestore()
    //   .collection("tournaments")
    //   .doc(this.props.tournament[".key"])
    //   .collection("brackets")
    //   .doc(this.props.bracket.id)
    //   .update(toUpdate);

    // var httpsReference = window.firebase
    //   .app()
    //   .storage("gs://tournament-uploads/")
    //   .refFromURL(urlToDelete);
    // httpsReference.delete().catch(function (error) {
    //   // Uh-oh, an error occurred!
    //   console.log(error.message);
    // });
  };

  getStorageRef = () => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        "sponsors/" + this.props.user.uid + "/" + this.props.tournament[".key"]
      );
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true,
      errorMessageSponsor: "",
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    let toUpdate = { errorMessageSponsor: getUploadErrorMessage(error, 1) };
    this.setState(toUpdate);
  };

  handleUploadSuccess = (filename) => {
    this.setState({ isUploading: false });
    const storageRef = this.getStorageRef();
    storageRef
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        let toUpdate = { sponsorLogoURL: url, newSponsorLogo: true };
        this.setState(toUpdate);
        // window.firebase
        //   .firestore()
        //   .collection("tournaments")
        //   .doc(this.props.tournament[".key"])
        //   .collection("sportParks")
        //   .doc(this.props.sportPark.id)
        //   .update(toUpdate);
      });
  };

  render() {
    let nameValid = this.state.name.length > 0 || !this.props.bracket;

    let allowedToUpload = false;
    if (
      (this.props.tournamentStatus || {}).status === 1 ||
      (this.props.tournamentStatus || {}).status === 2 ||
      (this.props.tournamentStatus || {}).status === 3 ||
      (this.props.userStatus || {}).status === 1 ||
      (this.props.userStatus || {}).status === 2 ||
      (this.props.userStatus || {}).status === 3
    ) {
      allowedToUpload = true;
    }

    let scoreType = this.state.scoreType;
    if (scoreType !== "default") {
      if ((this.props.tournament.scoringTypes || {})[scoreType] === undefined) {
        scoreType = "default";
      }
    }
    let numChildScoreTypes = 1;
    if (this.props.bracket) {
      // bracket: check for different scoreType in poules for bracket
      this.props.poules
        .filter((p) => p.bracket === this.props.bracket.id)
        .forEach((p) => {
          let scoreTPoule = p.scoreType;
          if (scoreTPoule !== "default") {
            if (
              (this.props.tournament.scoringTypes || {})[scoreTPoule] ===
              undefined
            ) {
              scoreTPoule = "default";
            }
          }
          if (scoreTPoule && scoreTPoule !== scoreType) {
            numChildScoreTypes++;
          }
        });

      // check subbrackets
      let subBrackets = [];
      this.props.allBrackets.forEach((b) => {
        if (b.subBracketTo) {
          let parentBracket = this.props.bracketsByKey[b.subBracketTo] || {};
          let findingRootBracket = true;
          while (findingRootBracket) {
            if (parentBracket.id === this.props.bracket.id) {
              findingRootBracket = false;
            } else if (parentBracket.subBracketTo) {
              parentBracket =
                this.props.bracketsByKey[parentBracket.subBracketTo];
            } else {
              findingRootBracket = false;
            }
          }
          if (parentBracket.id === this.props.bracket.id) {
            subBrackets.push(b);
          }
        }
      });
      subBrackets.forEach((b) => {
        let scoreT = b.scoreType;
        if (scoreT !== "default") {
          if (
            (this.props.tournament.scoringTypes || {})[scoreT] === undefined
          ) {
            scoreT = "default";
          }
        }
        if (scoreT && scoreT !== scoreType) {
          numChildScoreTypes++;
        }
        this.props.allPoules
          .filter((p) => p.bracket === b.id)
          .forEach((p) => {
            let scoreTP = p.scoreType;
            if (scoreTP !== "default") {
              if (
                (this.props.tournament.scoringTypes || {})[scoreTP] ===
                undefined
              ) {
                scoreTP = "default";
              }
            }
            if (scoreTP && scoreTP !== scoreType) {
              numChildScoreTypes++;
            }
          });
      });
    }
    if (numChildScoreTypes > 1 && !this.state.scoreTypeChanged) {
      scoreType = "multiple";
    }

    return (
      <div>
        {this.state.open && (
          <EditBracketDialog
            toggleDialog={this.toggleDialog}
            handleChange={this.handleChange}
            handleSizeChange={this.handleSizeChange}
            handleSubmit={this.handleSubmit}
            bracket={this.props.bracket}
            {...this.state}
            division={this.props.division}
            fase={this.props.fase}
            scoreType={scoreType}
            showMultiple={numChildScoreTypes > 1}
            setScoreType={this.setScoreType}
            nameValid={nameValid}
            handleNumEncountersChange={this.handleNumEncountersChange}
            subBracketTo={this.props.subBracketTo}
            tournament={this.props.tournament}
            toggleUpgradeDialog={this.props.toggleUpgradeDialog}
            allowedToUpload={allowedToUpload}
            // sponsor
            handleShowSponsorChange={this.handleShowSponsorChange}
            sponsorStorageRef={this.getStorageRef()}
            handleDeleteSponsor={this.handleDeleteSponsor}
            handleUploadStart={this.handleUploadStart}
            handleProgress={this.handleProgress}
            handleUploadError={this.handleUploadError}
            handleUploadSuccess={this.handleUploadSuccess}
            errorMessageSponsor={this.state.errorMessageSponsor}
            isUploadingSponsor={this.state.isUploading}
          />
        )}
        {this.props.bracket ? (
          <IconButton
            aria-label="Change"
            onClick={this.toggleDialog}
            style={{ color: "white", width: 25, height: 20 }}
          >
            <CreateIcon style={{ height: 20, position: "absolute", top: 2 }} />
          </IconButton>
        ) : (
          <Button
            size="small"
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
            style={{ width: 220 }}
          >
            <AddIcon style={{ height: 16, width: 16 }} />
            {languages.structure.bracket}
            {this.props.subtext && this.props.subtext}
          </Button>
        )}
      </div>
    );
  }
}

export default EditBracketContainer;
